import { render, staticRenderFns } from "./LitiZhuan.vue?vue&type=template&id=b38edcb6&"
import script from "./LitiZhuan.vue?vue&type=script&lang=js&"
export * from "./LitiZhuan.vue?vue&type=script&lang=js&"
import style0 from "./LitiZhuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports